import Vue from 'vue';
import Vuex from 'vuex';
import { getProductList } from '../api';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		// aboutcp.png
		picUrl: 'https://resource.cctc.cc/mobile/',
		keepAlive: [],
		Inprosecdata: '',
		productList: []
	},
	mutations: {
		setKeepAlive: (state, keepAlive) => {
			state.keepAlive = keepAlive;
		},
		setProductList(state, data) {
			state.productList = data;
		}
	},
	getters: {
		keepAlive: state => state.keepAlive,
		productList: state => state.productList
	},
	actions: {
		async getProductList({ commit }) {
			const res = await getProductList({
				level: 1
			});

			commit('setProductList', res);
		}
	}
});
